import { StoresContext } from '@App/contexts'
import React, { useContext, useState } from 'react'
import Button from '@Components/Buttons/Button'
import './index.scss'
import Pluralize from 'pluralize'
import ModalPortal from '@Components/Popups/ModalPortal'
import Popup from '@Components/Popups/Popup'
import ConfirmationPopup from '@Components/Popups/ConfirmationPopup'
import CatalogTransferWizardHeader from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/CatalogTransferWizardHeader'

const ExportCatalogStep = () => {
    const { transferCatalogSearchStore, catalogTransferWizardStore, wizardFlowStore } = useContext(StoresContext)
    const [popupOpen, setPopupOpen] = useState(false)

    const onExportClick = async () => {
        await catalogTransferWizardStore.exportWorksToExcel()
        setPopupOpen(true)
    }

    const workCount = catalogTransferWizardStore.exportCurrentSearch
        ? transferCatalogSearchStore.worksRightsHolder?.count || 0
        : catalogTransferWizardStore.currentCatalogTransfer?.sourcePublishers?.reduce(
              (sum, publisher) => sum + (publisher.totalWorks ?? publisher.worksCount ?? 0),
              0
          ) || 0

    return (
        <div className="ct-export-catalog-step ct-wizard-step-container">
            <CatalogTransferWizardHeader
                title="Export Works"
                subtitle="In this step you will review and confirm that each work selected should be included in the transfer."
            />
            <section className="export-catalog-content">
                <div className="export-catalog-instructions">
                    <p>
                        To get started, click the <strong>Export Works</strong> button below. An email with an Excel
                        file of your selected works will be sent to you.
                    </p>
                    <br />
                    <p>
                        Once you've opened the file, use the dropdown menu on the light green cells to select{' '}
                        <strong>YES</strong> for works you want to transfer and <strong>NO</strong> for works you don't
                        want to transfer.
                    </p>
                </div>

                <div className="export-catalog-button-container">
                    <div className="export-catalog-count">
                        <div>
                            {workCount} {Pluralize('Work', workCount)} to export
                        </div>
                    </div>
                    <Button mainColor type="primary" onClick={onExportClick}>
                        Export {Pluralize('Work', workCount)}
                    </Button>
                </div>
            </section>
            <ModalPortal isOpen={popupOpen} onClose={() => setPopupOpen(false)}>
                <Popup onClose={() => setPopupOpen(false)}>
                    <ConfirmationPopup
                        title="Export Complete"
                        onConfirm={() => wizardFlowStore.advanceIndex()}
                        confirmButtonText="Next"
                        popupClassName="export-complete-modal"
                    >
                        <div className="export-complete-copy">
                            <div className="export-complete-header">
                                The list of works you selected has been sent to your email as an Excel file.
                            </div>
                            <div>
                                After you have reviewed and confirmed the works you want to acquire in the Excel file,
                                click <strong>Next</strong> to upload your updated file.
                            </div>
                            <div>
                                Need help? Visit our{' '}
                                <a
                                    href="https://help.themlc.com/en/support/catalog-transfer-process-and-faqs"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Help Center
                                </a>{' '}
                                article.
                            </div>
                        </div>
                    </ConfirmationPopup>
                </Popup>
            </ModalPortal>
        </div>
    )
}

export default ExportCatalogStep
